/* =========================================================
   HERO
========================================================= */
import React from "react";

const HeroSection = ({ data }) => (
    <section id="hero-video" className="hero-video">

        <div className="hero-video-wrapper">

            <video
                autoPlay
                loop
                playsInline
                muted
            >
                <source
                    src={
                        data.videoUrl ||
                        "/assets/stemx365_website_home_intro.mp4"
                    }
                    type="video/mp4"
                />
            </video>

            {/* Desktop navigation */}
            <div className="video-floating-nav">
                <div className="video-floating-links">

                    {/* Existing competition links */}
                    {(data.competitions || []).map((item, i) => (
                        <a
                            key={i}
                            href={item.url || "#"}
                            className={item.className || "btn btn-primary"}
                        >
                            {item.text}
                        </a>
                    ))}

                    {/* Main CTA */}
                    <a
                        href="/rect/labs"
                        className="btn btn-primary hero-cta-start"
                    >
                        Explore Labs
                    </a>

                </div>
            </div>
        </div>

        {/* Mobile navigation */}
        <div className="video-mobile-nav">
            <div className="video-floating-links">

                {/* Existing competition links */}
                {(data.competitions || []).map((item, i) => (
                    <a
                        key={i}
                        href={item.url || "#"}
                        className={item.className || "btn btn-primary"}
                    >
                        {item.text}
                    </a>
                ))}

                {/* Main CTA */}
                <a
                    href="/rect/labs"
                    className="btn btn-primary hero-cta-start"
                >
                    Explore Labs
                </a>
            </div>
        </div>

    </section>
);

export default HeroSection;